import { render, staticRenderFns } from "./SetupMfa.vue?vue&type=template&id=efc4fe84&"
import script from "./SetupMfa.vue?vue&type=script&lang=js&"
export * from "./SetupMfa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports